<script setup lang="ts">
import { VButton, VModal, VSection, VTextField } from '@/modules/shared/components'
import useVuelidate from '@vuelidate/core'
import { email, required } from '@vuelidate/validators'
import { ref } from 'vue'

const props = defineProps<{
  modalStore: any
  onSubmit: (payload: any) => Promise<void>
}>()

const loading = ref(false)

const contactInitialState = {
  email: null,
  name: null,
}
const contactRules = {
  email: { email, required },
  name: { required },
}
const contactForm = ref({ ...contactInitialState })

const v$ = useVuelidate(contactRules, contactForm, { $lazy: true })

const resetForm = () => {
  v$.value.$reset()
  contactForm.value = { ...contactInitialState }
}

const submit = async () => {
  const valid = await v$.value.$validate()
  if (!valid) return

  loading.value = true
  await props.onSubmit(contactForm.value)
  loading.value = false
  resetForm()
}
</script>

<template>
  <VModal :modalStore="modalStore">
    <template #main>
      <VSection label="Add contact">
        <form @submit.prevent="submit">
          <div class="mt-6 space-y-3">
            <VTextField v-model="contactForm.name" label="Name" property="name" ref="autofocus" :v$="v$" />
            <VTextField v-model="contactForm.email" label="Email" property="email" :v$="v$" />
          </div>
          <button type="submit" class="hidden"></button>
          <!--- for some reason without this, the 'return' key doesnt trigger the form to submit -->
        </form>
      </VSection>
    </template>
    <template #footer>
      <div class="flex items-center justify-between space-x-3">
        <VButton :click="modalStore.close" size="lg">Close</VButton>
        <VButton :click="submit" :loading="loading" class="w-full" size="lg" variant="primary">
          <span>Add Contact</span>
        </VButton>
      </div>
    </template>
  </VModal>
</template>
